import { MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { LOCATIONS, BRAND } from "../data/site";

export default function Locations() {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="bg-cream-deep py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
              Find us
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-cocoa mt-3 leading-tight">
              Store <span className="gold-underline">Locator</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-cocoa-soft reveal">
            <p>
              Browse our kitchens across India. Walk in for the full handi
              experience or place an online order from your nearest outlet.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {LOCATIONS.map((loc, idx) => (
            <article
              key={loc.id}
              data-testid={`location-card-${loc.id}`}
              className="reveal bg-white rounded-2xl border border-cream-deep p-7 md:p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-center gap-4 min-w-0">
                  <div
                    className="shrink-0 w-14 h-14 rounded-xl bg-[#3A1B0E] flex items-center justify-center ring-1 ring-[#C8A14B]/40 overflow-hidden"
                    aria-hidden="true"
                  >
                    <img
                      src={BRAND.logoTransparent}
                      alt=""
                      className="w-12 h-12 object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-display text-2xl text-cocoa truncate">
                      {BRAND.name}
                    </h3>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-gold font-semibold mt-0.5">
                      {loc.city} · {loc.name}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 space-y-3 text-sm">
                <div className="flex items-center gap-3 text-cocoa">
                  <MapPin size={18} className="text-cocoa shrink-0" />
                  <span data-testid={`location-area-${loc.id}`}>
                    {loc.area || loc.city}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-cocoa">
                  <Clock size={18} className="text-cocoa shrink-0" />
                  <span>
                    <span className="font-semibold">Open from</span>{" "}
                    {loc.hours}
                  </span>
                </div>
              </div>

              <Link
                to={`/order/${loc.id}`}
                data-testid={`location-order-online-${loc.id}`}
                className="mt-7 w-full inline-flex items-center justify-center rounded-xl bg-[#C8A14B] text-[#3A1B0E] hover:bg-[#D4A24E] hover:-translate-y-0.5 transition-all px-6 py-3.5 font-semibold shadow-sm"
              >
                Order Online
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
